/**
 * Párrafo item
 * @param {*} editor
 */
function quotes(editor) {
  const cm = editor.codemirror;
  const selectedText = cm.getSelection();
  const text = selectedText;

  const output = `#39;${text}#39;`;
  cm.replaceSelection(output);
}

export default function () {
  const option = {
    name: 'Comillado',
    action: quotes,
    className: 'zmdi zmdi-quote',
    title: 'Comillado',
  };

  return option;
}
